export default __webpack_public_path__ + "static/media/hotel1.e431249a.jpg";